import React, { Component } from 'react';
import './style.css';
import {Link} from 'react-router-dom';
import Icon from 'react-icons-kit';
import {androidDelete} from 'react-icons-kit/ionicons/androidDelete';
import {edit} from 'react-icons-kit/ionicons/edit';

class DemographicsCategoriesList extends Component {
  constructor(props){
    super(props)
    this.state={
    };
   
  }

  createDemoCategory(){
      this.props.showCategoryAddDemographics();
  }

  softDeleteCategory(data){
    let data1 = {};
    data1.id = data._id;
    data1.cat_id = data.cat_id;
    this.props.softDeleteCategory(data1);
  }

  render(){

    let couponsDataList = "";
    if(this.props.demoGraphicsCategoriesListSuccess){
    if(this.props.demoGraphicsCategoriesList && this.props.demoGraphicsCategoriesList.length > 0){
        let categories = this.props.demoGraphicsCategoriesList;
        couponsDataList = Object.keys(categories).map((item, index) => {
        let categoryItem = categories[item];

        return <tr key={index} >
            <td style ={{ textAlign : "center" }}>{index+1}</td>
            <td style ={{ textAlign : "center" }}>{categoryItem.cat_id}</td>
            <td>{categoryItem.catName}</td>
            <td style ={{ textAlign : "center" }}>{categoryItem.order_no}</td>
            <td className = "cat_action">
            <Link to={{
              pathname: '/editDemographicsCategories',
              state: {
                editCategoryItemData : categoryItem
                // category_id : categoryItem._id,
                // catId : categoryItem.cat_id,
                // catName : categoryItem.catName,
                // catOrderNo : categoryItem.order_no,
              }
              }}>
              < Icon icon={edit} size={30} style={{ color: '#336699' }}/>
            </Link>
            <button onClick = {this.softDeleteCategory.bind(this, categoryItem)} className = "removebutton">< Icon icon={androidDelete} size={30} style={{ color: '#EF233C' }}/></button>            
            </td>
          </tr>
          });
    }else{
        couponsDataList = "No data"
    }
  }

  return (<div className = "userlist">
  <div className = "userlistbackground">
        <div className = "usertable"><h1>Demographics Categories List</h1></div>
     <button  className = "createCouponbtn" onClick={this.createDemoCategory.bind(this)}>Add Demographics Category</button>
        <div className = "autoscroll">
        <table className = "demoategoryTable">
          <thead>
            <tr >
              <th>Sr.No.</th>
              <th>Category</th>
              <th>Name</th>
              <th>Order No.</th>
              <th>Action</th> 
            </tr>
          </thead>
            <tbody> 
              {couponsDataList}  
            </tbody>
        </table>
        </div>
        </div>
        </div>
        
    );
  }
}
export default DemographicsCategoriesList;



// WEBPACK FOOTER //
// ./src/components/demographics/index.js